import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import {ajustesResources, inventarioResources, validadorClienteResources} from "../endpoints";
import useToken from "../useToken";

class DialogEditarPrecioBarra extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            articulo: props.fila.articulo,
            precio_final: "",
            barra: props.fila.barra,
            precio_barra: props.fila.precio_barra,
            dif_precio : props.fila.dif_precio,
            user: useToken.getUser(),
            abrirConfirmacion: false,
        }
    }
    verificaDifPrecio = () =>{
        if(this.state.dif_precio -(this.state.precio_final - this.state.precio_barra)>=2000){
            this.setState({abrirConfirmacion: true})
        }
        else{
            this.ajustarCantidad();
        }
    }
    
    ajustarCantidad = () =>{
        inventarioResources.modificaPreciobarra(this.state.barra, this.state.precio_final).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.props.refrescar("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }


    componentDidMount() {
        console.log(this.props)
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.motivo && this.state.cantidad_final){
                this.ajustarCantidad()
            }
        }
    }

    render() {
        return(
            <>
                <Dialog
                    open={!this.state.abrirConfirmacion}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Modificar precio barra</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12}>
                                Articulo: {this.state.articulo}
                            </Grid>
                            <Grid item xs={12}>
                                Barra: {this.state.barra}
                            </Grid>
                            <Grid item xs={12}>
                                Precio actual: {this.state.precio_barra}
                            </Grid>
                            <Grid item xs={12}>
                                Precio nuevo : <TextField value={this.state.precio_final} autoFocus={true} name="precio_final" fullWidth onChange={this.handleChange}/>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                            Cancelar
                        </Button>
                        <Button disabled={ !this.state.precio_final} variant="contained" onClick={this.verificaDifPrecio} color="primary">
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.abrirConfirmacion} // Controlado por el nuevo estado
                    aria-labelledby="confirm-dialog-title">
                    <DialogTitle id="confirm-dialog-title">Confirmar cambio de precio</DialogTitle>
                    <DialogContent>
                        La diferencia de precio sigue siendo masyor a $2000. ¿Estás seguro de que deseas cambiar el precio?
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            variant="contained" 
                            color="secondary" 
                            onClick={() => this.setState({ abrirConfirmacion: false })}
                        >
                            Cancelar
                        </Button>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={this.ajustarCantidad} // Si acepta, guarda definitivamente
                        >
                            Sí, Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
           
        )
    }
}

export default DialogEditarPrecioBarra;